import { render, staticRenderFns } from "./validation-tasks.vue?vue&type=template&id=16a43670"
import script from "./validation-tasks.vue?vue&type=script&lang=js"
export * from "./validation-tasks.vue?vue&type=script&lang=js"
import style0 from "./validation-tasks.vue?vue&type=style&index=0&id=16a43670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports